var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"visualizer"}},[(['SSO'].includes(_vm.artefact.type))?_c('div',[_c('mock',{key:_vm.artefact.query,attrs:{"artefact":_vm.artefact}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }